import React from "react";

function Divider() {
  return (
    <div className="mt-6 w-full max-md:max-w-full">
      <hr className="w-full border border-gray-200 border-solid min-h-px max-md:max-w-full" />
    </div>
  );
}

export default Divider;
